export function common() {
  let headerPosition = 100;

  const targetElement = document.getElementById("js-headerHeight");

  // スクロールに合わせて要素を移動（表示域から隠す）
  window.addEventListener("scroll", () => {
    // スクロール位置を保持
    let scrollPosition = document.documentElement.scrollTop;

    if (headerPosition <= scrollPosition) {
      targetElement.classList.add('is-height');
    } else if (headerPosition > scrollPosition) {
      targetElement.classList.remove('is-height');
    }
  });



  // フェードイン
  const scrollElements = document.querySelectorAll(".js-fadeIn");

  const elementInView = (el, dividend = 1) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
      elementTop <=
      (window.innerHeight - '100' || document.documentElement.clientHeight) / dividend
    );
  };

  const elementOutofView = (el) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
      elementTop > (window.innerHeight || document.documentElement.clientHeight)
    );
  };

  const displayScrollElement = (element) => {
    element.classList.add("scrolled");
  };

  const hideScrollElement = (element) => {
    element.classList.remove("scrolled");
  };

  const handleScrollAnimation = () => {
    scrollElements.forEach((el) => {
      if (elementInView(el, 1)) {
        displayScrollElement(el);
      } else if (elementOutofView(el)) {
        hideScrollElement(el)
      }
    })
  }

  window.addEventListener("scroll", () => {
    handleScrollAnimation();
  });

  window.addEventListener("load", () => {
    handleScrollAnimation();
  });

  // 言語の切り替え
  const PullDown = function () {
    const pullDowns = document.querySelectorAll('.js-pullDown');
    const windowWidth = window.innerWidth;
    const windowSm = 768;

    for (let pullDown of pullDowns) {

      // PCホバー時
      pullDown.addEventListener('mouseover', function () {
        this.classList.add("is-active");
      });
      pullDown.addEventListener('mouseleave', function () {
        this.classList.remove("is-active");
      });

      // スマホクリックー時
      if (windowWidth <= windowSm) {
        pullDown.addEventListener('click', function () {
          this.classList.toggle("is-active");
        });
      }
    }
  }
  PullDown();
}